import httpClient from 'utils/httpClient.js';

const path = '/warranty-package';

export const getWarrantyPackages = (params = {}) => httpClient.get(path, { params });
export const getWarrantyPackage = (id) => httpClient.get(`${path}/${id}`);
export const getWarrantyPackageByLegacyPeriod = (id) => httpClient.get(`${path}/legacy/${id}`);
export const getWarrantyPackageOptions = (params = {}) => httpClient.get(`${path}/options`, { params });
export const createWarrantyPackage = (payload) => httpClient.post(path, payload);
export const updateWarrantyPackage = (id, payload) => httpClient.put(`${path}/${id}`, payload);
export const deleteWarrantyPackage = (id) => httpClient.delete(`${path}/${id}`);
